export const enReviewsTranslations = {
    REVIEWS__DOWNLOAD_THE_REPORT: 'Download the report',
    REVIEWS__RADIO__TOTAL_REVIEWS: 'Total reviews',
    REVIEWS__RADIO__POSITIVE: 'Positive',
    REVIEWS__RADIO__NEGATIVE: 'Negative',
    REVIEWS__RADIO__NOT_RATED: 'Unrated',
    REVIEWS__RADIO__AVERAGE_RATING: 'Average rating',
    REVIEWS__OLD: 'Old first',
    REVIEWS__NEW: 'New first',
    REVIEWS__SORT__NEWEST: 'New first',
    REVIEWS__SORT__OLDEST: 'Old first',
    REVIEWS__SORT__RATING_ASC: 'Rating ascending',
    REVIEWS__SORT__RATING_DESC: 'Rating descending',
    REVIEWS__HEADER__SEARCH_PLACEHOLDER: 'Review text, reply text, or author details',

    REVIEWS__FILTER__RESET: 'Reset filter',
    REVIEWS__FILTER__SHOW_WITH_COUNT: 'Show ({count})',
    REVIEWS__FILTER__SAVE_FILTERS: 'Save filters',
    REVIEWS__FILTER__SAVE_FILTERS_TOOLTIP:
        'The filter will be saved after logout and applied automatically until you reset it or turn this option off.',
    REVIEWS__FILTER__SELECT_A_BRAND: 'Select a brand',
    REVIEWS__FILTER__SELECT_A_SOURCE: 'Select a source',
    REVIEWS__FILTER__SELECT_A_STATUS: 'Select a status',
    REVIEWS__FILTER__ANY_RATING: 'Any rating',
    REVIEWS__FILTER__DOCTOR_NAME: 'Select doctors',
    REVIEWS__FILTER__APP_NAME: 'Select an application',
    REVIEWS__FILTER__ANY_EMPLOYEE: 'Any employee',
    REVIEWS__FILTER__SELECT_AN_EMPLOYEE: 'Select employee(s)',
    REVIEWS__FILTER__ANY_DOCTOR: 'All doctors',
    REVIEWS__FILTER__SELECT_TAGS: 'Select tags',
    REVIEWS__FILTER__AUTO_REPLIES: 'Auto-replies',
    REVIEWS__FILTER__AUTO_REPLY_VIA_TEMPLATE: 'Using a template',
    REVIEWS__FILTER__AUTO_REPLY_VIA_NEURAL_NETWORK: 'Using a neural network',
    REVIEWS__FILTER__REVIEWS_WITHOUT_TEXT: 'Without text',
    REVIEWS__FILTER__REVIEWS_WITH_TEXT: 'With text',
    REVIEWS__FILTER__REVIEWS_WITH_A_RESPONSE: 'Has reply',
    REVIEWS__FILTER__REVIEWS_UNANSWERED: 'No reply',
    REVIEWS__FILTER__THERE_IS_A_POSSIBILITY_OF_AN_ANSWER: 'Yes',
    REVIEWS__FILTER__THERE_IS_NO_POSSIBILITY_OF_AN_ANSWER: 'No',
    REVIEWS__FILTER__REVIEWS_FOR_THE_BRAND: 'Brand',
    REVIEWS__FILTER__REVIEWS_FOR_COMPANIES: 'Companies',
    REVIEWS__FILTER__WITH_TAGS: 'Has tags',
    REVIEWS__FILTER__NO_TAGS: 'No tags',
    REVIEWS__FILTER__LABEL__BRAND: 'Brand',
    REVIEWS__FILTER__LABEL__SOURCE: 'Source',
    REVIEWS__FILTER__ALL__SOURCES: 'All sources',
    REVIEWS__FILTER__INTERNAL_AGENCY__LABEL: 'Agency employees who have responded',
    REVIEWS__FILTER__LABEL__RATING: 'Rating',
    REVIEWS__FILTER__LABEL__TOTAL_REVIEWS_WITH_COUNT: 'Total reviews: {count}',
    REVIEWS__FILTER__LABEL__AVERAGE_RATING: 'Average rating: {rating}',
    REVIEWS__FILTER__LABEL__PERIOD: 'Period',
    REVIEWS__FILTER__LABEL__COLLECTION_DATE: 'Review collection date',
    REVIEWS__FILTER__TAB__PUBLICATION_DATE: 'Publication date',
    REVIEWS__FILTER__TAB__COLLECTION_DATE: 'Collection date',
    REVIEWS__FILTER__LABEL__EMPLOYEE_REPLY_DATE: 'Employee reply date',
    REVIEWS__FILTER__LABEL__RESPONSIBLE: 'Assigned to',
    REVIEWS__FILTER__LABEL__EMPLOYEE_RESPONDING: 'Replied by',
    REVIEWS__FILTER__LABEL__STATUS: 'Status',
    REVIEWS__FILTER__LABEL__TONALITY: 'Tonality',
    REVIEWS__FILTER__SELECT_TONALITY: 'Select tonality',
    REVIEWS__FILTER__TONALITY__POSITIVE: 'Positive',
    REVIEWS__FILTER__TONALITY__NEGATIVE: 'Negative',
    REVIEWS__FILTER__TONALITY__NEUTRAL: 'Neutral',
    REVIEWS__FILTER__LABEL__TAGS: 'Tags',
    REVIEWS__FILTER__LABEL__INCLUDES_TAGS: 'Include tags',
    REVIEWS__FILTER__LABEL__AUTO_REPLIES: 'Auto-replies',
    REVIEWS__FILTER__LABEL__CONTENT_OF_REVIEWS: 'Reviews text',
    REVIEWS__FILTER__LABEL__HAS_NOTES: 'Has notes',
    REVIEWS__FILTER__LABEL__HIDDEN_REVIEW: 'Review hidden',
    REVIEWS__REVIEW_HIDE__HINT: 'Hide review',
    REVIEWS__REVIEW_UNHIDE__HINT: 'Remove from hidden',
    REVIEWS__REVIEW_HIDE__MODAL_TITLE: 'Hide review?',
    REVIEWS__REVIEW_HIDE__MODAL_CONTENT:
        'A hidden review stays in the feed and is marked as hidden.\n\nTo remove such reviews from the feed, set the "Hidden reviews — No" filter and save it.\n\nAfter hiding, you will not be able to reply to the review.',
    REVIEWS__REVIEW_HIDE__MODAL_OK: 'Hide',
    REVIEWS__REVIEW_HIDE__SUCCESS__TITLE: 'Review hidden',
    REVIEWS__REVIEW_HIDE__SUCCESS__DESCRIPTION:
        'The review is marked as hidden. To remove such reviews from the feed, set the "Hidden reviews — No" filter and save it.',
    REVIEWS__REVIEW_HIDE__ERROR__TITLE: 'Could not hide review',
    REVIEWS__REVIEW_HIDE__ERROR__DESCRIPTION: 'Please try again later or contact your account manager.',
    REVIEWS__REVIEW_UNHIDE__SUCCESS__TITLE: 'Review removed from hidden',
    REVIEWS__REVIEW_UNHIDE__SUCCESS__DESCRIPTION: 'The review is no longer marked as hidden.',
    REVIEWS__REVIEW_UNHIDE__ERROR__TITLE: 'Could not remove from hidden',
    REVIEWS__REVIEW_UNHIDE__ERROR__DESCRIPTION: 'Please try again later or contact your account manager.',
    REVIEWS__REVIEW_HIDDEN_TOOLTIP: 'Not available for hidden reviews',
    REVIEWS__BULK_HIDE__HINT: 'Hide reviews',
    REVIEWS__BULK_UNHIDE__HINT: 'Remove from hidden',
    REVIEWS__BULK_HIDE__MODAL_TITLE: 'Hide reviews?',
    REVIEWS__BULK_HIDE__MODAL_CONTENT:
        'Hidden reviews stay in the feed and are marked as hidden.\n\nTo remove such reviews from the feed, set the "Hidden reviews — No" filter and save it.\n\nAfter hiding, you will not be able to reply to the reviews.',
    REVIEWS__BULK_HIDE__SUCCESS__TITLE: 'Reviews hidden',
    REVIEWS__BULK_HIDE__SUCCESS__DESCRIPTION: 'Applied to {processedCount} reviews.',
    REVIEWS__BULK_HIDE__PARTIAL_DESCRIPTION:
        'Applied to {processedCount} reviews. Skipped {skippedCount} (already in the target state).',
    REVIEWS__BULK_HIDE__ERROR__TITLE: 'Could not hide reviews',
    REVIEWS__BULK_HIDE__ERROR__DESCRIPTION: 'Please try again later or contact your account manager.',
    REVIEWS__BULK_HIDE__DISABLED_TOOLTIP: 'None of the selected reviews can be hidden',
    REVIEWS__BULK_UNHIDE__SUCCESS__TITLE: 'Reviews removed from hidden',
    REVIEWS__BULK_UNHIDE__SUCCESS__DESCRIPTION: 'Applied to {processedCount} reviews.',
    REVIEWS__BULK_UNHIDE__PARTIAL_DESCRIPTION:
        'Applied to {processedCount} reviews. Skipped {skippedCount} (already in the target state).',
    REVIEWS__BULK_UNHIDE__ERROR__TITLE: 'Could not remove reviews from hidden',
    REVIEWS__BULK_UNHIDE__ERROR__DESCRIPTION: 'Please try again later or contact your account manager.',
    REVIEWS__BULK_UNHIDE__DISABLED_TOOLTIP: 'None of the selected reviews can be removed from hidden',
    REVIEWS__FILTER__LABEL__DELETED_REVIEWS: 'Reviews removed',
    REVIEWS__FILTER__LABEL__REPLIES_TO_REVIEWS: 'Replies',
    REVIEWS__FILTER__LABEL__POSSIBILITY_OF_AN_ANSWER: 'Can reply',
    REVIEWS__FILTER__LABEL__REVIEW_TYPE: 'Review type',
    REVIEWS__FILTER__LABEL__COMPLAINT_TYPE: 'Complaint type',
    REVIEWS__FILTER__COMPLAINT_TYPE__AUTO: 'Sent automatically',
    REVIEWS__FILTER__COMPLAINT_TYPE__MANUAL: 'Sent manually',
    REVIEWS__FILTER__LABEL__COMPLAINT_STATUS: 'Complaint status',
    REVIEWS__FILTER__COMPLAINT_STATUS__NOT_SENT: 'Not sent',
    REVIEWS__FILTER__COMPLAINT_STATUS__SENT: 'Sent',
    REVIEWS__FILTER__COMPLAINT_STATUS__ACCEPTED: 'Approved',
    REVIEWS__FILTER__COMPLAINT_STATUS__DECLINED: 'Declined',
    REVIEWS__FILTER__LABEL__REVIEW_CHANGED: 'Review updated',
    REVIEWS__FILTER__LABEL__WAITING_FOR_A_SECOND_ANSWER: 'Waiting for a second response',
    REVIEWS__FILTER__LABEL__MODERATED: 'Review verified',
    REVIEWS__FILTER__LABEL__OFFICIAL_RESPONSE_PUBLISHED: 'Official response published',
    REVIEWS__FILTER__LABEL__DOCTOR_NAME: 'Doctors',
    REVIEWS__FILTER__LABEL__APP_NAME: 'Application',
    REVIEWS__FILTER__SECTION__MAIN: 'Main filters',
    REVIEWS__FILTER__SECTION__EMPLOYEE: 'Employee',
    REVIEWS__FILTER__SECTION__TAGS: 'Tags',
    REVIEWS__FILTER__SECTION__ADDITIONAL: 'Additional',

    REVIEWS__REPLY: 'Reply',
    REVIEWS__PRESENCE__ANOTHER_USER: 'Another user is working on this review',
    REVIEWS__PRESENCE__BLOCKED__STATUS:
        'Another user is working on this review. Status change is unavailable until they finish.',
    REVIEWS__PRESENCE__BLOCKED__REPLY:
        'Another user is working on this review. Replying is unavailable until they finish.',
    REVIEWS__PRESENCE__BLOCKED__ABUSE:
        'Another user is working on this review. Submitting a report is unavailable until they finish.',
    REVIEWS__PRESENCE__BLOCKED__EDIT_REPLY:
        'Another user is working on this review. Editing a reply is unavailable until they finish.',
    REVIEWS__PRESENCE__BLOCKED__DELETE_REPLY:
        'Another user is working on this review. Deleting a reply is unavailable until they finish.',
    REVIEWS__PRESENCE__BLOCKED__RESPONSIBLE_USER:
        'Another user is working on this review. Assigning a responsible person is unavailable until they finish.',
    REVIEWS__PRESENCE__BLOCKED__REMOVE_RESPONSIBLE:
        'Another user is working on this review. Removing the responsible person is unavailable until they finish.',
    REVIEWS__PRESENCE__BLOCKED__BULK_SELECT:
        'Another user is working on this review. Bulk selection is unavailable until they finish.',
    REVIEWS__ADD_REPLY: 'Add a reply',
    REVIEWS__SAVE: 'Save',
    REVIEWS__ENTER_YOUR_REPLY_TEXT: 'Enter your reply text...',
    REVIEWS__ENTER_YOUR_REPLY: 'Enter your reply...',
    REVIEWS__AUTO_REPLY: 'Auto reply',
    REVIEWS__DIALOG: 'Dialog',
    REVIEWS__OFFERING_AUTO_REPLY: 'Offering an autoreply template',
    REVIEWS__OFFERING_NEURALLINK: 'Neural network suggestion',
    REVIEWS__OFFERING_AUTO_REPLY_SEND: 'Send an autoreply',
    REVIEWS__DELETE_ANSWER__TITLE: 'Deleting a response',
    REVIEWS__DELETE_ANSWER__DESCRIPTION:
        'Do you really want to delete the answer? The answer will also be deleted in the company cards.',
    REVIEWS__DELETE_AUTOANSWER__TITLE: 'Delete an autoresponder?',
    REVIEWS__DELETE_AUTOANSWER__DESCRIPTION: 'The auto-reply template suggestion will be deleted.',
    REVIEWS__RESPONSE_TIME: 'Reply time in the app: {time}',
    REVIEWS__RESPONSE_TIME__DURING_MINUTE: 'Responded within a minute',
    REVIEWS__RESPONSE_TIME_CATALOG: 'Reply time on site: {time}',
    REVIEWS__RESPONSE_EMPLOYEE: 'Employee: {name}',
    REVIEWS__POPOVER__COMPLAINT_HAS_BEEN_SENT__HEADER: 'The complaint has been sent {date}',
    REVIEWS__POPOVER__COMPLAINT_HAS_BEEN_SENT__TEXT:
        'The processing time for a complaint takes up to a week. If it is deemed reasonable, the review will no longer be displayed on the site.',
    REVIEWS__REVIEW__COMPANY_CODE__HINT: 'Company Code',
    REVIEWS__REVIEW_DELETED: 'Review deleted',
    REVIEWS__REVIEW_HIDDEN: 'Review hidden',
    REVIEWS__REVIEW_UNAVAILABLE_ANSWER: 'Answer unavailable',
    REVIEWS__REVIEW_UNAVAILABLE_ANSWER__LINK_TEXT: 'To answer, ',
    REVIEWS__REVIEW_UNAVAILABLE_ANSWER__LINK: 'connect your account',
    REVIEWS__REVIEW_UNAVAILABLE_ANSWER__TOOLTIP_TITLE: 'Source account not connected',
    REVIEWS__REVIEW_UNAVAILABLE_ANSWER__TOOLTIP_TEXT:
        'Connect the source account to send responses and complaints via {companyName}.',
    REVIEWS__REVIEW_UNAVAILABLE_ANSWER__BANNER_LINK: 'Connect your account',
    REVIEWS__REVIEW_UNAVAILABLE_ANSWER__BANNER_TEXT:
        '{link} a source account to send responses and complaints via {companyName}.',
    REVIEWS__REVIEW_UNAVAILABLE_COMPLAINT__POPUP_TITLE: 'Connect your account to report reviews',
    REVIEWS__REVIEW_UNAVAILABLE_COMPLAINT__POPUP_TEXT:
        'For this source, sending a complaint via RocketData is possible after connecting the source account.',
    REVIEWS__REVIEW_NOT_CONFIRMED: 'The review has not been confirmed',
    REVIEWS__REVIEW_NOT_CONFIRMED__DESCRIPTION:
        'The review is not confirmed by the catalog and is not displayed in it.',
    REVIEWS__REVIEW_HAS_ERROR_CONNECT_ACCOUNT: 'Correct the error for the response ',
    REVIEWS__REVIEW_HAS_ERROR_CONNECT_ACCOUNT__LINK: 'account connections',
    REVIEWS__REVIEW_HAS_ERROR_CONNECT_ACCOUNT__POPOVER_TITLE: 'Account Connection error',
    REVIEWS__REVIEW_HAS_ERROR_CONNECT_ACCOUNT__POPOVER_TEXT:
        'Sending responses and complaints via {companyName} is possible after the connection error has been resolved.',
    REVIEWS__REVIEW_HAS_ERROR_CONNECT_ACCOUNT__POPOVER_TEXT__LINK: 'Go to fix',
    REVIEWS__REVIEW_HAS_ERROR_CONNECT_ACCOUNT__BANNER_TEXT:
        'Sending responses and complaints via {companyName} is possible after the connection error has been resolved. {link}',
    REVIEWS__REVIEW__NO_TEXT: 'Review without text',
    REVIEW__PROBLEM_SOLVED_LABEL: 'Problem solved!',
    REVIEW__ADMINISTRATOR_LABEL: 'Administrator',
    REVIEWS__REVIEW__ATTACHMENTS__SINGLE: '{count} attachment',
    REVIEWS__REVIEW__ATTACHMENTS__FEW: '{count} attachments',
    REVIEWS__REVIEW__ATTACHMENTS__MANY: '{count} attachments',
    REVIEWS__REVIEW__ADD_TAG: 'Tag',
    REVIEWS__REVIEW_ANSWER_SEND_SUCCESS__TITLE: 'The response has been sent',
    REVIEWS__REVIEW_ANSWER_SEND_SUCCESS__DESCRIPTION: 'The response to the review has been sent successfully.',
    REVIEWS__BULK_ANSWER__CONFIRM_MODAL_TITLE: 'You cannot reply to all selected reviews',
    REVIEWS__BULK_ANSWER__CONFIRM_CONTENT__SINGULAR:
        'You can only reply to {canAnswerCount} of {totalCount} selected review. Send the reply to the eligible ones?',
    REVIEWS__BULK_ANSWER__CONFIRM_CONTENT__FEW:
        'You can only reply to {canAnswerCount} of {totalCount} selected reviews. Send the reply to the eligible ones?',
    REVIEWS__BULK_ANSWER__CONFIRM_CONTENT__MANY:
        'You can only reply to {canAnswerCount} of {totalCount} selected reviews. Send the reply to the eligible ones?',
    REVIEWS__BULK_ANSWER__CONFIRM_OK: 'Submit for eligible',
    REVIEWS__BULK_ANSWER__DISABLED_TOOLTIP: 'You cannot reply to any of the selected reviews',
    REVIEWS__BULK_ANSWER__TITLE: 'Enter a response to reviews',
    REVIEWS__BULK_ANSWER__PLACEHOLDER: 'Enter company response',
    REVIEWS__BULK_ANSWER__TEMPLATE__BUTTON: 'Response templates',
    REVIEWS__BULK_ABUSE__CONFIRM_TITLE: 'Not all reviews can be reported',
    REVIEWS__BULK_ABUSE__CONFIRM_MODAL_TITLE: 'You cannot complain about all selected reviews',
    REVIEWS__BULK_ABUSE__CONFIRM_CONTENT__SINGULAR:
        'You can only complain about {canAbuseCount} of {totalCount} selected review. Submit complaints for the eligible ones?',
    REVIEWS__BULK_ABUSE__CONFIRM_CONTENT__FEW:
        'You can only complain about {canAbuseCount} of {totalCount} selected reviews. Submit complaints for the eligible ones?',
    REVIEWS__BULK_ABUSE__CONFIRM_CONTENT__MANY:
        'You can only complain about {canAbuseCount} of {totalCount} selected reviews. Submit complaints for the eligible ones?',
    REVIEWS__BULK_ABUSE__CONFIRM_OK: 'Submit for eligible',
    REVIEWS__BULK_ABUSE__DISABLED_TOOLTIP: 'You cannot complain about any of the selected reviews',
    REVIEWS__BULK_STATUS__ALL_REPLACING_TOOLTIP: 'Status cannot be temporarily changed for any of the selected reviews',
    REVIEWS__BULK_STATUS__CONFIRM_TITLE: 'Not all selected reviews can have their status changed',
    REVIEWS__BULK_STATUS__CONFIRM_CONTENT__SINGULAR:
        'Status can only be changed for {canChangeCount} of {totalCount} selected review. Change status for the eligible ones?',
    REVIEWS__BULK_STATUS__CONFIRM_CONTENT__FEW:
        'Status can only be changed for {canChangeCount} of {totalCount} selected reviews. Change status for the eligible ones?',
    REVIEWS__BULK_STATUS__CONFIRM_CONTENT__MANY:
        'Status can only be changed for {canChangeCount} of {totalCount} selected reviews. Change status for the eligible ones?',
    REVIEWS__BULK_STATUS__CONFIRM_OK: 'Change status for eligible',
    REVIEWS__BULK_SELECTION__CHANGE_STATUS: 'Change status',
    REVIEWS__BULK_SELECTION__COMPLAIN: 'Report',
    REVIEWS__BULK_SELECTION__ADD_TAG: 'Add tag',
    REVIEWS__REVIEW_ANSWER_SEND_FAIL__TITLE: 'Failed to send response',
    REVIEWS__REVIEW_ANSWER_SEND_FAIL__DESCRIPTION: 'Please try again later, or contact tech support.',
    REVIEWS__REVIEW_ANSWER_CHANGE_TAG_FAIL: 'Failed to change tags',
    REVIEWS__REVIEW_ANSWER_CHANGE_TAG_SUCCESS: 'Tags successfully changed',
    REVIEWS__STATUS_CHANGE_SUCCESS: 'Statuses successfully changed',
    REVIEWS__REVIEW_ANSWER_REMOVE_SUCCESS__TITLE: 'Response deleted',
    REVIEWS__REVIEW_ANSWER_REMOVE_SUCCESS__DESCRIPTION: 'The response was successfully deleted',
    REVIEWS__REVIEW_ANSWER_REMOVE_FAIL__TITLE: 'Failed to delete response',
    REVIEWS__REVIEW_ANSWER_REMOVE_FAIL__DESCRIPTION: 'Please try again later, or contact tech support.',
    REVIEWS__REVIEW_AUTOANSWER_REMOVE_SUCCESS__TITLE: 'Auto-reply deleted',
    REVIEWS__REVIEW_AUTOANSWER_REMOVE_SUCCESS__DESCRIPTION:
        'The auto-reply template suggestion has been successfully deleted.',
    REVIEWS__REVIEW_AUTOANSWER_REMOVE_FAIL__TITLE: 'Error',
    REVIEWS__REVIEW_AUTOANSWER_REMOVE_FAIL__DESCRIPTION:
        'Could not delete the autoresponder. Try again later or contact tech support.',
    REVIEWS__REVIEW_COPY__HINT: 'Copy the review text',
    REVIEWS__REVIEW_COPY__SUCCESS: 'Review Text copied',
    REVIEWS__REVIEW_COPY__BROWSER_ERROR:
        'The review text could not be copied. Try updating your browser to the latest version',
    REVIEWS__REVIEW_URL_COPY__HINT: 'Copy link to review',
    REVIEWS__REVIEW_URL_COPY__SUCCESS: 'Review link copied',
    REVIEWS__REVIEW_DELETE__HINT: 'Delete a review',
    REVIEWS__REVIEW_EDIT__HINT: 'Edit a review',
    REVIEWS__REVIEW_ABUSE__HINT: 'Report a review',
    REVIEWS__REVIEW_ABUSE__ERROR_CONNECT_ACCOUNT__POPOVER__TITLE: 'Account Connection error',
    REVIEWS__REVIEW_ABUSE__ERROR_CONNECT_ACCOUNT__POPOVER__TEXT:
        'An error occurred connecting the source account. Sending a complaint via {companyName} is possible after the connection error has been resolved.',
    REVIEWS__REVIEW_ABUSE__ERROR_CONNECT_ACCOUNT__POPOVER__BUTTON: 'Fix',
    REVIEWS__REVIEW_CHANGE_HISTORY__HINT: 'Review has been changed',
    REVIEWS__REVIEW_CHANGE_HISTORY: 'Review change history',
    REVIEWS__REVIEW_CHANGE_HISTORY__BEFORE: 'Before',
    REVIEWS__REVIEW_CHANGE_HISTORY__AFTER: 'After',
    REVIEWS__REVIEW_CHANGE_HISTORY__RATING: 'Rating',
    REVIEWS__COMPLAINT_POPUP__SUBMITTING_A_COMPLAINT: 'Submitting a complaint',
    REVIEWS__COMPLAINT_POPUP__ENTER_YOUR_COMPLAINT_HERE: 'Enter your complaint here',
    REVIEWS__BULK_COMPLAINT__TITLE: 'Report Reviews',
    REVIEWS__COMPLAINT__COMPLAINT_HAS_BEEN_SENT: 'The complaint has been sent',
    REVIEWS__COMPLAINT__COMPLAINT_SENT_ERROR: 'Failed to send a complaint',
    REVIEWS__COMPLAINT__COMPLAINT_HAS_BEEN_SENT__DESCRIPTION:
        'The complaint about the review was sent successfully. The processing time for a complaint takes up to a week. If it is deemed reasonable, the review will no longer be displayed on the site.',
    REVIEWS__DOWNLOAD_REPORT_POPUP__HEADER: 'Download report',
    REVIEWS__DOWNLOAD_REPORT_POPUP__INFO: 'When uploading reviews, the selected filters will be applied',
    REVIEWS__DOWNLOAD_REPORT_POPUP__REVIEWS__EMPTY:
        'The review list is empty. Wait for filters to be collected or changed.',
    REVIEWS__DOWNLOAD_REPORT_POPUP__BUTTON__REQUEST: 'Request',
    REVIEWS__EXPORT_CONSTRUCTOR__BADGE__STANDARD: 'Standard',
    REVIEWS__EXPORT_CONSTRUCTOR__BADGE__CUSTOM: 'Custom',
    REVIEWS__EXPORT_CONSTRUCTOR__BASED_ON: 'Based on: {name}',
    REVIEWS__EXPORT_CONSTRUCTOR__UPDATED_AT: 'Updated {date}',
    REVIEWS__EXPORT_CONSTRUCTOR__CREATE_FROM_STANDARD: 'Create from standard template',
    REVIEWS__EXPORT_CONSTRUCTOR__CREATE_FROM_TEMPLATE: 'Create your own export\nbased on this one',
    REVIEWS__EXPORT_CONSTRUCTOR__CREATE_TITLE: 'Create custom export',
    REVIEWS__EXPORT_CONSTRUCTOR__EDIT_TITLE: 'Edit custom export',
    REVIEWS__EXPORT_CONSTRUCTOR__COLUMNS_LABEL: 'Export fields',
    REVIEWS__EXPORT_CONSTRUCTOR__PREVIEW_LABEL: 'Preview',
    REVIEWS__EXPORT_CONSTRUCTOR__PREVIEW_HINT: '(You can change the column order by dragging columns)',
    REVIEWS__EXPORT_CONSTRUCTOR__TAGS_FORMAT_LABEL: 'Tags format',
    REVIEWS__EXPORT_CONSTRUCTOR__AUTOTAGS_FORMAT_LABEL: 'Autotags format',
    REVIEWS__EXPORT_CONSTRUCTOR__FORMAT_COMMA: 'Comma-separated in one column',
    REVIEWS__EXPORT_CONSTRUCTOR__FORMAT_SEPARATE: 'Each tag in a separate column',
    REVIEWS__EXPORT_CONSTRUCTOR__BUTTON__SAVE: 'Save',
    REVIEWS__EXPORT_CONSTRUCTOR__DELETE__TITLE: 'Delete template?',
    REVIEWS__EXPORT_CONSTRUCTOR__DELETE__DESCRIPTION: 'Template "{name}" will be deleted and cannot be restored.',
    REVIEWS__EXPORT_CONSTRUCTOR__DELETE__SUCCESS: 'Template deleted',
    REVIEWS__EXPORT_CONSTRUCTOR__SAVE__SUCCESS: 'Template saved',
    REVIEWS__EXPORT_CONSTRUCTOR__LIMIT_REACHED: 'Custom template limit reached (50)',
    REVIEWS__EXPORT_CONSTRUCTOR__COLUMNS_REQUIRED: 'Select at least one field',
    REVIEWS__EXPORT_CONSTRUCTOR__NAME_REQUIRED: 'Enter template name',
    REVIEWS__EXPORT_CONSTRUCTOR__NAME_PLACEHOLDER: 'Enter export name',
    REVIEWS__REVIEWS_PARSED_AT: 'Review collected in dashboard: {date}',
    REVIEWS__REVIEWS_IN_CATALOG: 'Review in source: {date}',
    REVIEWS__REVIEW_ANSWER__TOOLTIP_TITLE__SENT: 'Response sent and awaiting publication',
    REVIEWS__REVIEW_ANSWER__TOOLTIP_TITLE__PUBLISH: 'Response published',
    REVIEWS__REVIEW_ANSWER__AUTHOR__COMPANY: 'Company response',
    REVIEWS__REVIEW_ANSWER__AUTHOR__USER: 'User response',
    REVIEWS__REVIEW_ANSWER__TEMPLATE__HINT: 'Response templates',
    REVIEWS__REPLY__EMOJI_PICKER__HINT: 'Add emoji',
    REVIEWS__REVIEW_ANSWER_CREATED_AT: 'Created: {date}',
    REVIEWS__RESPONSIBLE_USER__NOT_SELECTED: 'Not assigned',
    REVIEWS__RESPONSIBLE_USER__PLACEHOLDER: 'Responsible',
    REVIEWS__RESPONSIBLE_USER__ASSIGNED: 'Responsible assigned',
    REVIEWS__RESPONSIBLE_USER__ASSIGNED_DESCRIPTION: 'Responsible for the review assigned {name}',
    REVIEWS__RESPONSIBLE_USER__REMOVED: 'Responsible for the review removed',
    REVIEWS__RESPONSIBLE_USER__ASSIGN_ERROR: 'Failed to assign responsible user',
    REVIEWS__RESPONSIBLE_USER__ASSIGN_ERROR_DESCRIPTION: 'Please try again later or contact your account manager',
    REVIEWS__ENTER_NOTE_TITLE: 'Note',
    REVIEWS__ENTER_NOTE_EDITING: 'Editing',
    REVIEWS__ENTER_NOTE_EDITED: 'Edited',
    REVIEWS__ENTER_YOUR_NOTE_TEXT: 'Enter note text here',
    REVIEWS__REVIEW_NOTE_SEND_SUCCESS_TITLE: 'Note created',
    REVIEWS__REVIEW_NOTE_SEND_SUCCESS_DESCRIPTION: 'Review note successfully created.',
    REVIEWS__REVIEW_NOTE_SEND_FAIL: 'Failed to create note',
    REVIEWS__REVIEW_NOTE_CHANGE_SUCCESS_TITLE: 'Note changed',
    REVIEWS__REVIEW_NOTE_CHANGE_SUCCESS_DESCRIPTION: 'The note has been successfully modified.',
    REVIEWS__REVIEW_NOTE_CHANGE_FAIL: 'Failed to edit note',
    REVIEWS__REVIEW_NOTE_DELETE_SUCCESS_TITLE: 'Note deleted',
    REVIEWS__REVIEW_NOTE_DELETE_SUCCESS_DESCRIPTION: 'The note has been successfully deleted.',
    REVIEWS__REVIEW_NOTE_DELETE_FAIL: 'Failed to delete note',
    REVIEWS__REVIEW_NOTE_DELETE_CONFIRM_TITLE: 'Deleting a note',
    REVIEWS__REVIEW_NOTE_DELETE_CONFIRM_QUESTION: 'Are you sure you want to delete the note?',
    REVIEWS__REVIEW_NOTE_DELETE_CONFIRM_BUTTON: 'Delete',
    REVIEWS__REVIEW_NOTE_CREATED_BY: 'User {user} created note',
    REVIEWS__REVIEW_NOTE_UPDATED_BY: 'User {user} changed note',
    REVIEWS__REVIEW_NOTE_DELETED_BY: 'Note deleted by user {user}',
    REVIEWS__REVIEW_LOG__RESPONSIBLE_USER__CREATED: 'appointed a responsible person',
    REVIEWS__REVIEW_LOG__RESPONSIBLE_USER__DELETED: 'removed the responsible person',
    REVIEWS__REVIEW_LOG__RESPONSIBLE_USER__UPDATED: 'changed the responsible person',
    REVIEWS__REVIEW_LOG__TAG__CREATED_BY_USER: '{user} added tag(s)',
    REVIEWS__REVIEW_LOG__TAG__DELETED_BY_USER: '{user} removed tag(s)',
    REVIEWS__REVIEW_LOG__TAG__CREATED: 'User {user} added tag(s)',
    REVIEWS__REVIEW_LOG__TAG__DELETED: 'User {user} removed tag(s)',
    REVIEWS__REVIEW_ABUSE_AUTO_SENT: 'Complaint sent automatically',
    REVIEWS__REVIEW_ABUSE_CREATED_BY: '{user} sent a complaint about the review',
    REVIEWS__REVIEW_ABUSE_UPDATED_BY: '{user} changed the review complaint',
    REVIEWS__REVIEW_ABUSE_DELETED_BY: '{user} deleted the review complaint',
    REVIEWS__REVIEW_ABUSE_LOG_STATUS__ERROR: 'Complaint sending error',
    REVIEWS__REVIEW_ABUSE_LOG_STATUS__NOT_SENT: 'Complaint not sent',
    REVIEWS__REVIEW_ABUSE_LOG_STATUS__REVIEW_NOT_FOUND: 'Review not found',
    REVIEWS__REVIEW_ABUSE_STATUS_UPDATED: 'Complaint status updated',
    REVIEWS__REVIEW_ABUSE_STATUS_UPDATED__DATE_TOOLTIP:
        'This is the date the status changed in our dashboard, as platforms do not provide the time of their decision.',
    REVIEWS__REVIEW_ABUSE__SHOW_TEXT: 'Expand the text',
    REVIEWS__REVIEW_ABUSE__HIDE_TEXT: 'Collapse the text',
    REVIEWS__REVIEW_STATUS__CHANGE: '{user} changed the status',
    REVIEWS__REVIEW_HISTORY__DELETED_ON_CATALOG: 'The review was removed from the platform',
    REVIEWS__REVIEW_HISTORY__RESTORED_ON_CATALOG: 'The review was restored on the platform',
    REVIEWS__REVIEW_HISTORY__MOVED_TO_CONFIRMED_ON_CATALOG: 'The review was moved to confirmed on the platform',
    REVIEWS__REVIEW_HISTORY__MOVED_TO_UNCONFIRMED_ON_CATALOG: 'The review was moved to unconfirmed on the platform',
    REVIEWS__REVIEW_HISTORY__REPLY__CREATED: '{user} sent a reply to the review in the account',
    REVIEWS__REVIEW_HISTORY__REPLY__UPDATED: '{user} changed the reply to the review in the account',
    REVIEWS__REVIEW_HISTORY__REPLY__DELETED: '{user} deleted the reply to the review in the account',
    REVIEWS__REVIEW_SENTIMENT__CHANGE: '{user} changed the review sentiment',
    REVIEWS__ASPECT_SENTIMENT__CHANGE: '{user} changed the aspect sentiment',

    REVIEWS__DOWNLOAD_REPORT_POPUP__FULL_UNLOADING_OF_REVIEWS__HEADER__NEW: 'Full upload of reviews (new version)',
    REVIEWS__DOWNLOAD_REPORT_POPUP__FULL_UNLOADING_OF_REVIEWS__TOOLTIP_TITLE__NEW: 'new version',
    REVIEWS__DOWNLOAD_REPORT_POPUP__FULL_UNLOADING_OF_REVIEWS__TOOLTIP_CONTENT__NEW:
        'An upload that can be constantly updated',
    REVIEWS__DOWNLOAD_REPORT_POPUP__FULL_UNLOADING_OF_REVIEWS__HEADER__OLD: 'Full upload of reviews (old version)',
    REVIEWS__DOWNLOAD_REPORT_POPUP__FULL_UNLOADING_OF_REVIEWS__TOOLTIP_TITLE__OLD: 'Old version',
    REVIEWS__DOWNLOAD_REPORT_POPUP__FULL_UNLOADING_OF_REVIEWS__TOOLTIP_CONTENT__OLD:
        'An upload that is no longer updated, it remains in the same state',
    REVIEWS__DOWNLOAD_REPORT_POPUP__FULL_UNLOADING_OF_REVIEWS__TEXT: 'Reviews and answers',
    REVIEWS__DOWNLOAD_REPORT_POPUP__FULL_UNLOADING_OF_REVIEWS__PLACEHOLDER: 'Full unloading of reviews',
    REVIEWS__DOWNLOAD_REPORT_POPUP__REVIEW_STATISTICS_BY_BRAND_AND_CITY__HEADER: 'Review statistics by brand and city',
    REVIEWS__DOWNLOAD_REPORT_POPUP__REVIEW_STATISTICS_BY_BRAND_AND_CITY__TEXT:
        'Changes in review ratings for the selected period',
    REVIEWS__DOWNLOAD_REPORT_POPUP__REVIEW_STATISTICS_BY_BRAND_AND_CITY__PLACEHOLDER:
        'Review statistics by brand and city',
    REVIEWS__DOWNLOAD_REPORT_POPUP__RESPONSE_STATISTICS_BY_BRAND_AND_CITY__HEADER:
        'Response statistics by brand and city',
    REVIEWS__DOWNLOAD_REPORT_POPUP__RESPONSE_STATISTICS_BY_BRAND_AND_CITY__TEXT:
        'Number of unanswered reviews and average response rate',
    REVIEWS__DOWNLOAD_REPORT_POPUP__RESPONSE_STATISTICS_BY_BRAND_AND_CITY__PLACEHOLDER:
        'Response statistics by brand and city',
    REVIEWS__DOWNLOAD_REPORT_POPUP__REVIEW_STATISTICS_BY_BRAND_AND_CITY__FEEDBACK_REPORT: 'Feedback report',
    REVIEWS__DOWNLOAD_REPORT_POPUP__REVIEW_STATISTICS_BY_BRAND_AND_CITY__TAG_REPORT: 'Tag report',
    REVIEWS__DOWNLOAD_REPORT_POPUP__COMMENTS_LAYOUT__LABEL: 'Comments format',
    REVIEWS__DOWNLOAD_REPORT_POPUP__COMMENTS_LAYOUT__ROWS: 'By rows',
    REVIEWS__DOWNLOAD_REPORT_POPUP__COMMENTS_LAYOUT__COLUMNS: 'By columns',
    REVIEWS__DOWNLOAD_REPORT_POPUP__RATING_STATISTICS_BY_SOURCE__HEADER: 'Rating statistics by source',
    REVIEWS__DOWNLOAD_REPORT_POPUP__RATING_STATISTICS_BY_SOURCE__TEXT:
        'Rating of reviews in sources for the selected period',
    REVIEWS__DOWNLOAD_REPORT_POPUP__RATING_STATISTICS_BY_SOURCE__PLACEHOLDER: 'Rating statistics by source',
    REVIEWS__DOWNLOAD_REPORT_POPUP__RATING_STATISTICS_GOOGLE_YANDEX_GIS__HEADER:
        'Rating of companies on the sources of Google, Yandex, 2GIS',
    REVIEWS__DOWNLOAD_REPORT_POPUP__RATING_STATISTICS_GOOGLE_YANDEX_GIS__TEXT: 'Over the last 24 hours',
    REVIEWS__DOWNLOAD_REPORT_POPUP__RATING_STATISTICS_GOOGLE_YANDEX_GIS__PLACEHOLDER:
        'Rating of companies on the sources of Google, Yandex, 2GIS',
    REVIEWS__DOWNLOAD_REPORT_POPUP__THE_APPLICATION_HAS_BEEN_ACCEPTED__HEADER: 'The application has been accepted',
    REVIEWS__DOWNLOAD_REPORT_POPUP__THE_APPLICATION_HAS_BEEN_ACCEPTED__TEXT:
        'The requested report will be sent to you by email specified in your profile.',
    REVIEWS__DOWNLOAD_REPORT_POPUP__THE_APPLICATION_ERROR_SENT: 'Failed to send request',
    REVIEWS__DOWNLOAD_REPORT_POPUP__NAME__LABEL__TITLE: 'Download name',
    REVIEWS__DOWNLOAD_REPORT_POPUP__NAME__HINT__TITLE: 'Download name',
    REVIEWS__DOWNLOAD_REPORT_POPUP__ADDITIONAL_DATA__LABEL__TITLE: 'Additional data in the upload',
    REVIEWS__DOWNLOAD_REPORT_POPUP__NAME__HINT__TEXT:
        'You can change the name of the uploaded file or leave the default one.',
    REVIEWS__TAGS_POPUP__HEADER: 'Tags',
    REVIEWS__TAGS_POPUP__BULK_HEADER: 'Add tags to selected reviews',
    REVIEWS__AUTOTAGS_POPUP__HEADER: 'Autotags',
    REVIEWS__TAGS_POPUP__SEARCH_FOR_TAGS: 'Search for tags',
    REVIEWS__TAGS_POPUP__ALL_GROUPS: 'All groups',
    REVIEWS__TAGS_POPUP__GO_TO_TAG_SETUP: 'Go to tag setup',
    REVIEWS__TAGS_POPUP__REFRESH: 'Refresh tag list',
    REVIEWS__BULK_TAGS__SUCCESS_TITLE: 'Tags added',
    REVIEWS__BULK_TAGS__SUCCESS_DESCRIPTION: 'Applied to {processedCount} reviews.',
    REVIEWS__BULK_TAGS__PARTIAL_DESCRIPTION:
        'Applied to {processedCount} reviews. Skipped {skippedCount} (they already had all selected tags).',
    REVIEWS__BULK_TAGS__ERROR: 'Failed to add tags',
    REVIEWS__BULK_NOTE__SUCCESS_TITLE: 'Notes added',
    REVIEWS__BULK_NOTE__SUCCESS_DESCRIPTION: 'Added to {processedCount} reviews.',
    REVIEWS__BULK_NOTE__ERROR: 'Failed to add notes',
    REVIEW__FORM__MODAL__HEADER__ADDING: 'Add review',
    REVIEW__FORM__MODAL__HEADER__EDITING: 'Edit review',
    REVIEW__FORM__MODAL__ADD_ONE_MORE_REVIEW: 'Add one more review',
    REVIEW__FORM__MODAL__NO_RATING: 'Without rating',
    REVIEW__FORM__FIELD_SOURCE: 'Source',
    REVIEW__FORM__FIELD_BRAND: 'Brand',
    REVIEW__FORM__FIELD_COMPANY: 'Company',
    REVIEW__FORM__FIELD_CREATED_DATE: 'Created date',
    REVIEW__FORM__FIELD_AUTHOR: 'Name',
    REVIEW__FORM__FIELD_PHONE: 'Phone',
    REVIEW__FORM__FIELD_RATING: 'Rating',
    REVIEW__FORM__FIELD_CONTENT: 'Review text',
    REVIEW__FORM__FIELD_ATTACHMENTS: 'Attachments',
    REVIEW__FORM__FIELD_ATTACHMENTS__UPLOAD_BUTTON: 'Upload photo or video',
    REVIEW__FORM__FIELD_ATTACHMENTS__FILE_FORMAT_ERROR: 'Unsupported file format',
    REVIEW__FORM__FIELD_ATTACHMENTS__FILE_SIZE_IMAGE_ERROR: 'Photo size exceeds 5 MB',
    REVIEW__FORM__FIELD_ATTACHMENTS__FILE_SIZE_VIDEO_ERROR: 'Video size exceeds 10 MB',
    REVIEW__FORM__FIELD_ATTACHMENTS__UPLOAD_ERROR: 'Failed to upload file',
    REVIEW__FORM__FIELD_ATTACHMENTS__VIEW_PHOTO: 'Expand',
    REVIEW__FORM__FIELD_ATTACHMENTS__VIEW_VIDEO: 'Watch',
    REVIEW__FORM__FIELD_BRAND__PLACEHOLDER: 'Select brand',
    REVIEW__FORM__FIELD_AUTHOR__PLACEHOLDER: 'Name and surname',
    REVIEW__FORM__FIELD_PHONE__PLACEHOLDER: 'Phone number with a country code and operator',
    REVIEW__FORM__FIELD_CONTENT__PLACEHOLDER: 'Enter a text of the review here...',
    REVIEW__FORM__CREATED__SUCCESS_HEADER: 'Review saved',
    REVIEW__FORM__CREATED__SUCCESS_BODY: 'Your review has been successfully added',
    REVIEW__FORM__EDITED__SUCCESS_BODY: 'Your review has been successfully updated',
    CUSTOM_REIVEW__DELETE_MODAL_TITLE: 'Delete review?',
    CUSTOM_REIVEW__DELETE_MODAL_CONTENT: 'Review will be deleted',
    CUSTOM_REIVEW__DELETE__SUCCESS__TITLE: 'The review has been deleted',
    CUSTOM_REIVEW__DELETE__SUCCESS__DESCRIPTION: 'Your review has been successfully deleted from the system.',

    REVIEW_IMPORT__COMPANY_CHOOSE_BUTTON: 'Select',
    REVIEW_IMPORT__COMPANY_PLACEHOLDER: 'Select company',
    REVIEW_IMPORT__REVIEW_TYPE_LABEL: 'Review type',
    REVIEW_IMPORT__REVIEW_TYPE_TOOLTIP:
        'Choose whether imports apply to every company in the brand or to a single company.',
    REVIEW_IMPORT__FILE_UPLOAD_LABEL: 'File upload',
    REVIEW_IMPORT__DOWNLOAD_TEMPLATE: 'Download template',
    REVIEW_IMPORT__FILE_UPLOAD_HINT: 'Upload Excel (xlsx/xls)',
    REVIEW_IMPORT__FILE_UPLOAD_HINT__CSV: 'or CSV file',
    REVIEW_IMPORT__TAGS_TOOLTIP: 'Added tags will be applied to all reviews in the file.',
    REVIEW_IMPORT__SUCCESS: 'Reviews from the file ({count}) were successfully added to the system.',
    REVIEW_IMPORT__ROW_ERROR: 'Row {row}: {message}',
    REVIEW_IMPORT__ROW_ERROR_WITH_FIELD: 'Row {row}, field {field}: {message}',

    REVIEW_ITEM_PAGE__TITLE: 'View review',
    REVIEW_ITEM_PAGE__ACTIVITY__REPLIES__SINGLE: '{count} reply',
    REVIEW_ITEM_PAGE__ACTIVITY__REPLIES__FEW: '{count} replies',
    REVIEW_ITEM_PAGE__ACTIVITY__REPLIES__MANY: '{count} replies',
    REVIEW_ITEM_PAGE__ACTIVITY__NOTES__SINGLE: '{count} note',
    REVIEW_ITEM_PAGE__ACTIVITY__NOTES__FEW: '{count} notes',
    REVIEW_ITEM_PAGE__ACTIVITY__NOTES__MANY: '{count} notes',
    REVIEW_ITEM_PAGE__ACTIVITY__LOGS: 'History',
    REVIEW_ITEM_PAGE__ACTIVITY__LOGS__CREATED: 'Review added to the catalog',
    REVIEW_ITEM_PAGE__ACTIVITY__LOGS__CREATED__BY_USER: 'User {user} created a review',
    REVIEW_ITEM_PAGE__ACTIVITY__NEURO_NETWORK_RESPONSE__TITLE: 'Neural network response',
    REVIEW_ITEM_PAGE__ACTIVITY__NEURO_NETWORK_RESPONSE__OPTION: 'Proposal:',
    REVIEW_ITEM_PAGE__ACTIVITY__NEURO_NETWORK_RESPONSE__EDIT_MARK: '- editing',
    REVIEW_ITEM_PAGE__NO_TEXT_TITLE: 'Review without text',

    REVIEW__DROPDOWN_MENU__OPEN_LINK: 'Open in a new tab',
    REVIEW__DROPDOWN_MENU__ADD_NOTE: 'Add a note',
    REVIEW__DROPDOWN_MENU__APPOINT_RESPONSIBLE: 'Assign responsible person',

    REVIEW__NEW_DESIGN__SWITCHER: 'New Design',
    REVIEW__NEW_DESIGN_MODAL__TITLE: 'Try the New Design',
    REVIEW__NEW_DESIGN_MODAL__FOOTER__CANCEL: 'Revert to the Old Version',
    REVIEW__NEW_DESIGN_MODAL__FOOTER__CONFIRM: 'Continue with the New Design',
    REVIEW__NEW_DESIGN_MODAL__CONTENT__DESCRIPTION:
        "We know it may be unusual to see the new version of the section, but don't rush to give up on it!",
    REVIEW__NEW_DESIGN_MODAL__CONTENT__LIST__TITLE: 'In the future, we will add:',
    REVIEW__NEW_DESIGN_MODAL__CONTENT__LIST__PARAGRAPH_1: 'New features to simplify work and increase efficiency.',
    REVIEW__NEW_DESIGN_MODAL__CONTENT__LIST__PARAGRAPH_2: 'Enhancements for smoother and more intuitive interactions.',
    REVIEW__NEW_DESIGN_MODAL__CONTENT__ALERT:
        'Please note that the old design will only be available for a limited time.',
    REVIEWS__COMPLAINT_POPUP__OFFENSIVE_CONTENT: 'Offensive or Obscene Content',
    REVIEWS__COMPLAINT_POPUP__2GIS__NO_CLIENT: 'There was no such client',
    REVIEWS__COMPLAINT_POPUP__MENTION_COMPETITOR: 'Mentions Competitor',
    REVIEWS__COMPLAINT_POPUP__NOT_APPLY_THIS_COMPANY: 'Does Not Apply to This Company',
    REVIEWS__COMPLAINT_POPUP__PRIVACY_VIOLATION: 'Privacy Violation',
    REVIEWS__COMPLAINT_POPUP__GOOGLE__OFF_TOPIC: 'Off topic',
    REVIEWS__COMPLAINT_POPUP__GOOGLE__SPAM: 'Spam',
    REVIEWS__COMPLAINT_POPUP__GOOGLE__CONFLICT_OF_INTEREST: 'Conflict of interest',
    REVIEWS__COMPLAINT_POPUP__GOOGLE__PROFANITY: 'Profanity',
    REVIEWS__COMPLAINT_POPUP__GOOGLE__HARMFUL: 'Harmful',
    REVIEWS__COMPLAINT_POPUP__GOOGLE__BULLYING: 'Bullying or harassment',
    REVIEWS__COMPLAINT_POPUP__GOOGLE__HATE_SPEECH: 'Discrimination or hate speech',
    REVIEWS__COMPLAINT_POPUP__GOOGLE__PERSONAL_INFORMATION: 'Personal information',
    REVIEWS__COMPLAINT_POPUP__GOOGLE__NOT_HELPFUL: 'Not helpful',
    REVIEWS__NOTE_MODAL__TITLE: 'Adding a note',
    REVIEWS__SENTIMENT__NOT_SELECTED: 'Not selected',
    REVIEWS__NOTE__EDIT: 'Edit note',
    REVIEWS__NOTE__DELETE: 'Delete note',

    REVIEW__ABUSE_STATUS__SENT: 'Complaint sent',
    REVIEW__ABUSE_STATUS__ACCEPTED: 'Complaint approved',
    REVIEW__ABUSE_STATUS__DECLINED: 'Complaint declined',
    REVIEW__ABUSE_STATUS_DESCRIPTION__ACCEPTED: 'The review is no longer displayed on the platform.',
    REVIEW__ABUSE_STATUS_DESCRIPTION__AUTO_SENT: 'Auto-complaint sent',
    REVIEW__ABUSE_STATUS_DESCRIPTION__AUTO_SENT__TITLE: 'Complaint was sent automatically',
    REVIEW__ABUSE_STATUS_DESCRIPTION__AUTO_SENT__DESCRIPTION:
        "The review was checked for compliance with the platform's rules. Violations were detected, and a complaint was sent automatically.",
    REVIEW__ABUSE_STATUS_DESCRIPTION__CHECKED__TITLE: 'Review under verification',
    REVIEW__ABUSE_STATUS_DESCRIPTION__CHECKED__DESCRIPTION:
        "We are checking the possibility of automatic complaint filing. If violations of the platform's rules are detected, a complaint will be sent automatically.",
    REVIEW__ABUSE_STATUS_DESCRIPTION__YANDEX: 'The catalog has rejected the complaint about this review',
    REVIEWS__ABUSE__TEMPLATE__BUTTON: 'Templates',
    REVIEW__AUTO_TAG__TITLE: 'Autotag',
    REVIEW__TAG__DELETE: 'Delete tag',
    REVIEW__SENT_ANSWER_IN_CABINET: 'Response to the review sent in the account',
    REVIEW__POST_ANSWER_IN_CATALOG: 'Response to the review published on the platform',
    REVIEW__RESPONSE_TIME: 'Response time: {time}',
    REVIEW__SAVE_ANSWER: 'Save response',

    REVIEW__CUSTOM_FORM__GENERAL_SETTINGS: 'General settings',
    REVIEW__CUSTOM_FORM__AUTHOR: 'Author',
    REVIEW__CUSTOM_FORM__REVIEW_SETTING: 'Review',

    REVIEW__IRRELEVANT_TOOLTIP__TITLE: 'Your response is outdated because the review has been modified',
    REVIEW__IRRELEVANT_TOOLTIP__TEXT: 'Outdated',
    REVIEW__SOURCES_BANNER__TITLE: 'Collect more reviews! Connect new sources',
    REVIEW__SOURCES_BANNER__BUTTON: 'Connect sources',
    REVIEW__ANSWER__COMPANY_IS_NOT_CONFIRMATION__STATUS: 'To reply, {link}',
    REVIEW__ANSWER__COMPANY_IS_NOT_CONFIRMATION__STATUS__LINK: 'confirm the company',
    REVIEW__ANSWER__COMPANY_IS_NOT_CONFIRMATION: 'Company not confirmed',
    REVIEW__ANSWER__COMPANY_IS_NOT_CONFIRMATION__DESCRIPTION:
        'Confirm the company to send replies and complaints via {companyName}.',
    REVIEW__ANSWER__CONFIRMATION_MODAL__TITLE: 'Confirm the company to submit complaints about reviews',
    REVIEW__ANSWER__CONFIRMATION_MODAL__CONTENT:
        'For this source, submitting a complaint via {companyName} is possible only after company confirmation.',
    REVIEW__QR_CODE__FILTER__TITLE: 'QR Code Tags',
    REVIEW__MAILINGS__FILTER__TITLE: 'Mailings Tags',
    REVIEW__CUSTOM_FORM__REVIEW_NOTES: 'Notes',
    REVIEW__DROPDOWN_MENU__TO_SOURCES_SETTING: 'Go to Sources settings',
    REVIEW__DROPDOWN_MENU__HANDLE_ON_AUTOTAGS: 'Enable autotags',
    REVIEW__DROPDOWN_MENU__HANDLE_OFF_AUTOTAGS: 'Disable autotags',
    REVIEW__DROPDOWN_MENU__SNACKBAR__AUTOTAGS_TURNED_ON: 'Autotags enabled successfully',
    REVIEW__DROPDOWN_MENU__SNACKBAR__AUTOTAGS_TURNED_OFF: 'Autotags disabled successfully',
    REVIEW__DROPDOWN_MENU__REPLY_SEND_SETTINGS: 'Configure message sending',
    REVIEW__DROPDOWN_MENU__REPLY_SEND_SETTINGS__MODAL__TITLE: 'Keys for sending messages',
    REVIEW__DROPDOWN_MENU__REPLY_SEND_SETTINGS__MODAL__VARIANT_1: '{buttonOne} for line break, {buttonTwo}for sending',
    REVIEW__DROPDOWN_MENU__REPLY_SEND_SETTINGS__MODAL__VARIANT_2: '{buttonOne} for sending, {buttonTwo}for line break',
    REVIEW__DROPDOWN_MENU__REPLY_SEND_SETTINGS__MODAL__DESCRIPTION:
        'Choose which key combination will send the message and which will insert a line break.',
    REVIEW__DROPDOWN_MENU__REPLY_SEND_SETTINGS__SUCCESS_TITLE: 'Changes saved',
    REVIEW__DROPDOWN_MENU__REPLY_SEND_SETTINGS__SUCCESS_DESCRIPTION: 'Message sending key settings have been saved.',
    REVIEW__ABUSE__SEND_AGAIN: 'Send another complaint',
    REVIEW__ABUSE_STATUS_DESCRIPTION__DECLINED: 'You can try to send the complaint again',
    REVIEW__ADD_REVIEW__TOOLTIP: 'Add review',
    REVIEW__ADD_REVIEW__MANUALLY: 'Add manually',
    REVIEW__ADD_REVIEW__OPEN_ACTIONS_MENU: 'More ways to add a review',
    REVIEW__ADD_REVIEW__UPLOAD_FROM_FILE: 'Upload reviews from file',
    REVIEW__CONDITION__UNAVAILABLE__TITLE: 'Response from dashboard unavailable',
    REVIEW__CONDITION__UNAVAILABLE__DESCRIPTION: 'You can try going to the platform and replying there.',
    REVIEW__CONDITION__NOT_CONFIRMED__TITLE: 'Review not confirmed',
    REVIEW__CONDITION__NOT_CONFIRMED__DESCRIPTION:
        'The review is not confirmed by the catalog and is not displayed there.',
    REVIEW__CONDITION__ACCOUNT_SYNC__TITLE: 'Active account synchronization in progress',
    REVIEW__CONDITION__ACCOUNT_SYNC__DESCRIPTION:
        'Sending responses and complaints via {companyName} will be available after account synchronization is complete.',
    REVIEW__CONDITION__WITHOUT_TEXT__TITLE: 'Review without text',
    REVIEW__CONDITION__WITHOUT_TEXT__DESCRIPTION:
        "It's not possible to reply to or complain about textless reviews on 2GIS according to platform rules.",
    REVIEW__CONDITION__MANUALLY_ADDED__DESCRIPTION: 'Replies to manually added reviews are not available.',
    REVIEW__CONDITION__GENERATED__DESCRIPTION: 'Replies to generated reviews are not available.',
    REVIEW__CONDITION__ONLY_VISIBLE_TO_YOU__TITLE: 'Review is visible only to you',
    REVIEW__CONDITION__ONLY_VISIBLE_TO_YOU__DESCRIPTION:
        'Negative generated reviews are not available for viewing on the internet.',
    REVIEWS__REVIEW_CHANGE_HISTORY__ON_CATALOG: 'The review was edited on the platform:',
    REVIEW__ANSWER_TIMER__MESSAGE: 'The editing time has expired. The answer has been submitted for processing.',
    REVIEW__ANSWER_TIMER__DESCRIPTION: 'Editing is still available for {time}',
    REVIEW__ANSWER_TIMER__EXPIRED_BLOCK: 'Editing time has expired',
    REVIEW__REQUIRED_GROUP__ALERT: 'Add tags from groups: {tagsGroup}',
    REVIEW__INTERNAL_GENERATION_BUTTON__EMPTY_NOTIFICATION: 'No reviews available for generating a response',
    REVIEW__INTERNAL_GENERATION_BUTTON__TITLE: 'G🐹t some replies',
    REVIEWS__SELECTED_COUNT: 'Selected reviews: {selectedCount}',
    REVIEWS__SELECTED_LABEL: 'Selected',

    RATING_THRESHOLD__STAR_1: '1 star and more',
    RATING_THRESHOLD__STAR_2: '2 stars and more',
    RATING_THRESHOLD__STAR_3: '3 stars and more',
    RATING_THRESHOLD__STAR_4: '4 stars and more',
    RATING_THRESHOLD__STAR_5: '5 stars',

    REVIEWS__STATUS__CREATE_STATUS_BUTTON: 'Create status',
    REVIEWS__STATUS__CREATE_STATUS_PLACEHOLDER: 'Enter status name',
    REVIEWS__STATUS__DELETE_STATUS_TOOLTIP: 'Delete status',
    REVIEWS__STATUS__DELETE_MODAL_TITLE: 'Delete status?',
    REVIEWS__STATUS__DELETE_MODAL_DESCRIPTION:
        'All reviews with this status will need to be moved to another status. Choose which status to replace it with.',
    REVIEWS__STATUS__DELETE_MODAL_SELECT_PLACEHOLDER: 'Select a status',
    REVIEWS__STATUS__DELETE_MODAL_CONFIRM: 'Replace and delete',
    REVIEWS__STATUS__CREATE_SUCCESS: 'Status created successfully',
    REVIEWS__STATUS__DELETE_SUCCESS: 'Status deleted successfully',
    REVIEWS__STATUS__SYSTEM_STATUS_DELETE_TOOLTIP: 'System status, deletion unavailable',
    REVIEWS__STATUS__DEFAULT_DELETE_MODAL_DESCRIPTION:
        'The status will be removed from the selection list. If the current review had this status, it will be moved to the selected one.',
    REVIEWS__STATUS__DELETED_STATUS_TOOLTIP:
        'This status has been deleted. Replacement is in progress. Selection is temporarily unavailable.',
    REVIEWS__STATUS__REPLACING_IN_PROGRESS: 'Status replacement in progress',
    REVIEWS__STATUS__TOUR_TITLE: 'New Feature: Customizable Statuses',
    REVIEWS__STATUS__TOUR_DESCRIPTION:
        'Create custom statuses to accurately classify reviews and manage workflows more efficiently.',
};
